module.exports = __webpack_public_path__ + "static/img/chenshali_2.6342107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chenshali_2.png
// module id = Z0hL
// module chunks = 1